<template>
  <div class="transportDeliveryOrder">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClickBtn"
      @searchBtnClick="searchBtnClick"
      @searchCompanyName="searchCompanyName"
      @setBusinessType="setBusinessType"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :type="item.type"
          :params="item.params"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <template
              v-else-if="['requestAmount', 'paidAmount', 'unpaidAmount'].includes(item.field)"
            >
              {{
                userInfo.businessGroup == '物贸'
                  ? $utils.commafy($utils.toNumber(replaceZeroStr(scope.row[item.field])), {
                      digits: 2,
                    })
                  : replaceZeroStr(scope.row[item.field])
              }}
            </template>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <sirui-upload
      :action="action"
      :isShowDownTemplateBtn="true"
      ref="SiruiUpload"
      @getData="getNoCheckData"
      :data="{ ...tokenInfo }"
    ></sirui-upload>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/financeCenter/paymentApply';
  import DataBaseAPI from '@/api/dataBase';
  // import AGENCY_API from '@/api/agencyContract/index';
  import { filterEmpty } from '@/common/js/util';
  // import MASTER_API from '@/api/masterData/company.js';
  import tableMixins from '@/common/mixins/table.js';
  import qs from 'qs';
  import siruiUpload from '@/components/SiruiUpload';
  import loading from '@/common/js/load.js'; //loading
  import XEUtils from 'xe-utils';
  import { getUserCompanyList } from '@/common/js/util';
  export default {
    name: 'paymentApplyList',
    mixins: [tableMixins],
    components: {
      siruiUpload,
    },
    data() {
      return {
        footerTotalCols: { amount: ['requestAmount', 'paidAmount', 'unpaidAmount'], uniqKey: 'id' }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        action: API.IMPORT,
        templateAction: API.DOWNLOAD_TEMPLATE,
        query: {
          // startRequestAmount: undefined,
          // endRequestAmount: undefined,
          requestCompanyCode: undefined,
          requestDepartmentCode: undefined,
          judgeFlag: null,
          unpaidAmount: null,
          supplyChainNos: null,
          supplyChainNo: null,
          paymentApplyNumberLike: null,
          payeeNos: null,
          paymentMethod: null,
          paymentType: null,
          requestStatus: null,
          requestPersonName: null,
          expenseType: null,
          startRequestAmount: null,
          endRequestAmount: null,
          purchaseOrderNo: null,
          salesOrderNo: null,
          startRequestDate: null,
          endRequestDate: null,
          startGmtCreate: null,
          endGmtCreate: null,
          currencyCode: null,
          expenseDesc: null,
          settlementBusinessType: null,
          requestDepartmentNameLike: null,
        },
        departmentList: [], //部门列表
        //表格显示字段
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          {
            field: 'requestCompanyCode',
            title: 'paymentApplyList.table.requestCompanyCode',
            visible: true,
            width: 120,
          },
          {
            field: 'requestCompanyName',
            title: 'paymentApplyList.table.requestCompanyName',
            visible: true,
            width: 120,
          },
          {
            field: 'requestDepartmentCode',
            title: 'paymentApplyList.table.requestDepartmentCode',
            visible: true,
            width: 120,
          },
          {
            field: 'orderCode',
            title: '订单编码',
            visible: true,
            width: 150,
          },
          {
            field: 'requestStatus',
            title: '单据状态',
            visible: true,
            width: 120,
            fixed: 'right',
            dictType: 'payment_apply_request_status',
          },
          {
            field: 'requestDepartmentName',
            title: 'paymentApplyList.table.requestDepartmentName',
            visible: true,
            width: 120,
          },
          {
            field: 'settlementBusinessType',
            title: '业务类别',
            visible: true,
            width: 120,
            dictType: 'businessCategoryPayable',
          },
          {
            field: 'paymentApplyNumber',
            title: 'paymentApplyList.table.paymentApplyNumber',
            visible: true,
            width: 120,
          },
          {
            field: 'detailRequestAccountedAmount',
            title: '申请金额',
            visible: true,
            width: 120,
            // format: 'formatAmountRound',
          },
          {
            field: 'detailPaidAccountedAmount',
            title: '已付金额',
            visible: true,
            width: 120,
            // format: 'formatAmountRound',
          },
          {
            field: 'detailUnpaidAccountedAmount',
            title: '未付金额',
            visible: true,
            width: 120,
            // format: 'formatAmountRound',
          },
          {
            field: 'payeeName',
            title: 'paymentApplyList.table.payeeNo',
            visible: true,
            width: 120,
          },
          {
            field: 'bankName',
            title: 'paymentApplyList.table.bankName',
            visible: true,
            width: 120,
          },
          {
            field: 'bankAccount',
            title: 'paymentApplyList.table.bankAccount',
            visible: true,
            width: 120,
            format: 'formatBankcard',
          },
          {
            field: 'currencyCode',
            title: 'paymentApplyList.table.currencyName',
            visible: true,
            width: 120,
            dictType: 'all_currency',
          },
          {
            field: 'paymentType',
            title: 'paymentApplyList.table.paymentType',
            visible: true,
            width: 120,
            dictType: 'payment_type',
          },
          {
            field: 'paymentMethod',
            title: 'paymentApplyList.table.paymentMethod',
            visible: true,
            width: 120,
            dictType: 'apply_payment_method',
          },
          {
            field: 'expenseDesc',
            dictType: 'expense_item',
            title: 'paymentApplyList.search.expenseType',
            visible: true,
            width: 120,
          },
          // { field: 'isPrepay', title: '预付', visible: true, width: 120, dictType: 'yes-no' },
          // { field: 'paymentUsage', title: '汇款用途', visible: true, width: 120 },
          {
            field: 'requestPersonName',
            title: 'paymentApplyList.table.requestPersonName',
            visible: true,
            width: 120,
          },
          {
            field: 'requestDate',
            title: 'paymentApplyList.table.requestDate',
            visible: true,
            width: 120,
          },

          // 付款状态
          {
            field: 'paymentStatus',
            title: 'paymentApplyList.table.paymentStatus',
            visible: true,
            width: 120,
            fixed: 'right',
            dictType: 'payment_status',
          },
          // 采购合同
          {
            field: 'purchaseOrderNo',
            title: 'paymentApplyListAdd.invoiceLine.table.purchaseOrderNo',
            visible: true,
            width: 120,
          },
          // 销售合同
          {
            field: 'salesOrderNo',
            title: 'paymentApplyListAdd.invoiceLine.table.salesOrderNo',
            visible: true,
            width: 120,
          },
          // {
          //   field: 'gmtCreate',
          //   title: 'fundPaymentApply.column.gmtCreate',
          //   visible: true,
          //   width: 120,
          // },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        dictList: (state) => state.dict.dictList,
        tokenInfo() {
          return {
            access_token: this.userInfo.access_token,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            tenantCode: this.userInfo.tenantCode,
            businessGroup: this.userInfo.businessGroup,
          };
        },
      }),
      //搜索字段
      searchColumns() {
        let expenseDescDict = 'expense_item';
        if (this.query.settlementBusinessType) {
          switch (this.query.settlementBusinessType) {
            case '01':
              break;
            case '02':
              expenseDescDict = 'intermodality_expense_item';
              break;
            case '03':
              expenseDescDict = 'park_expense_item';
              break;
            case '04':
              expenseDescDict = 'supervise_expense_item';
              break;
          }
        }

        return [
          {
            prop: 'requestCompanyCode',
            name: this.$t('payablesBillList.search.payableInvoiceCompanyName'),
            type: 'select',
            placeholder: this.$t('payablesBillList.search.companyNamePlaceholder'),
            options: getUserCompanyList(),
            relatedColumn: 'none',
            changeMethod: 'searchCompanyName',
            required: true,
          },
          {
            prop: 'requestDepartmentCode',
            name: this.$t('payablesBillList.search.payableInvoiceDepartmentCode'),
            placeholder: this.$t('payablesBillList.search.departPlaceholder'),
            type: 'select',
            relatedColumn: 'none',
            options: this.departmentList,
            required: true,
          },
          {
            prop: 'paymentApplyNumberLike',
            name: this.$t('paymentApplyList.search.paymentApplyNumber'),
            type: 'input',
            placeholder: this.$t('paymentApplyList.search.paymentApplyNumberPlaceholder'),
          },
          {
            prop: 'payeeNos',
            name: this.$t('paymentApplyList.search.payeeNos'),
            type: 'searchTableSpec',
            searchType: 'partner',
            extraData: {
              companyCode: this.query.requestCompanyCode,
              departmentCode: this.query.requestDepartmentCode,
              partnerTypes: '',
              requestStatus: 'ZT03',
            },
            isMultiple: true,
            placeholder: this.$t('paymentApplyList.search.payeeNosPlaceholder'),
          },
          {
            prop: 'orderCodeLike',
            name: '订单编码',
            type: 'input',
          },
          {
            type: 'dictSelect',
            prop: 'paymentMethod',
            name: this.$t('paymentApplyList.search.paymentMethod'),
            apiData: { dictType: 'apply_payment_method' },
            placeholder: this.$t('paymentApplyList.search.paymentMethodPlaceholder'),
            clearable: true,
          },
          {
            type: 'dictSelect',
            prop: 'paymentType',
            name: this.$t('paymentApplyList.search.paymentType'),
            apiData: { dictType: 'payment_type' },
            placeholder: this.$t('paymentApplyList.search.paymentTypePlaceholder'),
            clearable: true,
          },
          {
            type: 'dict',
            prop: 'currencyCode',
            name: '币别',
            dictType: 'all_currency',
            placeholder: '请选择币别',
            clearable: true,
          },
          {
            type: 'dictSelect',
            prop: 'requestStatus',
            name: this.$t('paymentApplyList.search.requestStatus'),
            apiData: { dictType: 'payment_apply_request_status' },
            placeholder: this.$t('paymentApplyList.search.requestStatusPlaceholder'),
            clearable: true,
          },
          // {
          //   type: 'searchTableSpec',
          //   prop: 'requestPersonName',
          //   placeholder: this.$t("paymentApplyList.search.requestPersonNamePlaceholder"),
          //   name: this.$t("paymentApplyList.search.requestPersonName"),
          //   isMultiple: true,
          //   searchType: 'personnel'
          // },
          {
            prop: 'requestPersonName',
            name: '申请人',
            type: 'input',
            placeholder: this.$t('paymentApplyList.search.requestPersonNamePlaceholder'),
          },
          {
            type: 'dict',
            prop: 'expenseDesc',
            dictType: expenseDescDict,
            name: this.$t('paymentApplyList.search.expenseType'),
            placeholder: this.$t('paymentApplyList.search.expenseTypePlaceholder'),
            clearable: true,
          },
          {
            prop: 'startGmtCreate',
            placeholder: this.$t('paymentApplyList.search.startGmtCreatePlaceholder'),
            name: this.$t('paymentApplyList.search.startGmtCreate'),
            type: 'startDaterangePicker',
          },
          {
            prop: 'endGmtCreate',
            name: this.$t('paymentApplyList.search.endGmtCreate'),
            placeholder: this.$t('paymentApplyList.search.endGmtCreateDatePlaceholder'),
            type: 'endDaterangePicker',
          },
          {
            type: 'inputRange',
            prop: ['startRequestAmount', 'endRequestAmount'],
            max: 99999999999999.99,
            name: this.$t('paymentApplyList.search.startRequestAmount'),
          },
          {
            prop: 'purchaseOrderNo',
            name: this.$t('paymentApplyList.search.purchaseOrderNo'),
            type: 'input',
            // type: 'searchTableSpec',
            // isMultiple: true,
            // searchType: 'commonContract',
            // getSeachCode: 'contractNoLike',
            disabled: this.query.settlementBusinessType == '03',
            // parseExtendMap: true,
            // extraData: {
            //   businessCategory: this.query.settlementBusinessType,
            //   contractCompanyNo: this.query.requestCompanyCode,
            //   contractDepartmentNo: this.query.requestDepartmentCode,
            //   contractCategory: 'purchase',
            //   contractDetailCategory: 'CG01',
            //   customerNo: this.query.payeeNos,
            // },
            placeholder: this.$t('paymentApplyList.search.purchaseOrderNoPlaceholder'),
          },
          {
            prop: 'salesOrderNos',
            name: this.$t('paymentApplyList.search.salesOrderNo'),
            type: 'input',
            // type: 'searchTableSpec',
            // isMultiple: true,
            disabled: this.query.settlementBusinessType == '04',
            // searchType: 'commonContract',
            // parseExtendMap: true,
            // extraData: {
            //   businessCategory: this.query.settlementBusinessType,
            //   contractCompanyNo: this.query.requestCompanyCode,
            //   contractDepartmentNo: this.query.requestDepartmentCode,
            //   contractCategory: 'sale',
            //   contractDetailCategory: 'CG04',
            //   customerNo: this.query.payeeNos,
            // },
            placeholder: this.$t('paymentApplyList.search.salesOrderNoPlaceholder'),
          },
          {
            type: 'selectInput',
            prop: ['judgeFlag', 'unpaidAmount'],
            name: this.$t('paymentApplyList.search.unpaidAmount'),
            placeholder: this.$t('paymentApplyList.search.unpaidAmountPlaceholder'),
            options: [
              { value: 1, label: '大于' },
              { value: 2, label: '小于' },
              { value: 3, label: '不等于' },
              { value: 4, label: '等于' },
              { value: 5, label: '大于等于' },
              { value: 6, label: '小于等于' },
            ],
          },
          {
            prop: 'startRequestDate',
            placeholder: this.$t('paymentApplyList.search.startRequestDatePlaceholder'),
            name: this.$t('paymentApplyList.search.startRequestDate'),
            type: 'startDaterangePicker',
          },
          {
            prop: 'endRequestDate',
            name: this.$t('paymentApplyList.search.endRequestDate'),
            placeholder: this.$t('paymentApplyList.search.endRequestDatePlaceholder'),
            type: 'endDaterangePicker',
          },
          {
            prop: 'settlementBusinessType',
            name: '业务类别',
            placeholder: '请选择业务类别',
            type: 'select',
            options: this.dictListMap.businessCategoryPayable,
            changeMethod: 'setBusinessType',
          },
          {
            prop: 'isPrepay',
            name: this.$t('paymentApplyList.search.isPrepay'),
            placeholder: this.$t('paymentApplyList.search.isPrepayPlaceholder'),
            type: 'checkbox',
          },
          {
            name: '部门',
            prop: 'requestDepartmentNameLike',
            type: 'input',
          },
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      if (this.userInfo.companyCode != 'OAC19') {
        // this.query.requestCompanyCode = this.userInfo.companyCode;
        // this.query.requestDepartmentCode = this.userInfo.departmentCode;
        // this.getdepartmentList(this.query.requestCompanyCode);
      }
      this.getNoCheckData();
      this.getButtonList();
    },
    methods: {
      getDictValue({ cellValue, column }) {
        return this.$baseRequest.getDictValueByType(column.params.name, cellValue);
      },
      //获取数据
      getData() {
        console.log('查询列表');
        let query = this.setSearchParams();
        // if (!query.requestCompanyCode || !query.requestDepartmentCode) {
        //   this.$message({ showClose: true, message: '公司部门必填', type: 'error' });
        //   return;
        // }
        // if(params.payeeNos){
        //   params.payeeNos = this.query.map(item => {
        //     return i.partnerCode
        //   })
        // }
        if (
          (query.startRequestAmount && !query.endRequestAmount) ||
          (!query.startRequestAmount && query.endRequestAmount)
        ) {
          if (query.startRequestAmount) {
            query.endRequestAmount = query.startRequestAmount;
          } else {
            query.startRequestAmount = query.endRequestAmount;
          }
        }
        this.$axios.post(API.LIST_FUND_PAYMENT_APPLY_BY_PAGE, filterEmpty(query)).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.records || [];
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 查询参数整理
      setSearchParams() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        if (
          !this.$utils.isEmpty(this.query.endRequestAmount) &&
          this.$utils.isEmpty(this.query.startRequestAmount)
        ) {
          this.query.startRequestAmount = this.query.endRequestAmount;
        }
        const query = { ...this.query, pageSize, pageNum };
        if (query.payeeNos && query.payeeNos.length > 0) {
          // const { partnerCode } = query.payeeNos[0];
          if (query.payeeNos && query.payeeNos[0] && query.payeeNos[0].partnerCode) {
            query.payeeNo = query.payeeNos[0].partnerCode;
            delete query.payeeNos;
          }
        }
        if (
          query.supplyChainNos &&
          query.supplyChainNos.length > 0 &&
          query.supplyChainNos[0].supplierCode
        ) {
          const { supplierCode } = query.supplyChainNos[0];
          query.supplyChainNo = supplierCode;
          delete query.supplyChainNos;
        }
        // if (query.purchaseOrderNos && query.purchaseOrderNos.length > 0) {
        //   const { contractNo } = query.purchaseOrderNos[0];
        //   query.purchaseOrderNo = contractNo;
        //   delete query.purchaseOrderNos;
        // }
        // if (query.salesOrderNos && query.salesOrderNos.length > 0) {
        //   const { contractNo } = query.salesOrderNos[0];
        //   query.salesOrderNo = contractNo;
        //   delete query.salesOrderNos;
        // }
        if (query.isPrepay) {
          query.isPrepay = 1;
        } else {
          query.isPrepay = 0;
        }
        return query;
      },
      // 选择公司
      searchCompanyName(val) {
        console.log(val);
        this.departmentList = [];
        this.query.requestDepartmentCode = '';
        this.getdepartmentList(val.val);
      },
      setBusinessType(val) {
        console.log('businessTypeChanged', val);
        this.query.expenseDesc = null;
        this.query.purchaseOrderNo = null;
        this.query.purchaseOrderNos = null;
        this.query.salesOrderNo = null;
        this.query.salesOrderNos = null;
      },
      // 根据公司查询部门
      getdepartmentList(companyCode) {
        this.$axios.post(DataBaseAPI.LIST_DEPARTMENT_API + '/' + companyCode).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        // let flag = null;
        //拷贝销售提单
        if (type === 'add') {
          this.add();
        } else if (type === 'edit') {
          if (this.multipleSelection.length !== 1) {
            this.$message({
              showClose: true,
              message: '请选择一条数据修改',
              type: 'error',
            });
          } else {
            const item = this.multipleSelection[0];
            if (['Saved', 'Rejected', 'Withdraw', 'Freeze'].indexOf(item.requestStatus) != -1) {
              let path = {
                path: '/payment/paymentApplyAdd',
                name: 'paymentApplyAdd',
                meta: {
                  keepAlive: true,
                  title: '付款申请单编辑',
                },
                query: { id: item.id, isEdit: 'Y' },
              };
              this.$store.dispatch('tagsView/addTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path);
                });
              });
            } else {
              this.$message({
                showClose: true,
                message: '该状态无法编辑',
                type: 'error',
              });
            }
          }
        } else if (type === 'export') {
          this.export();
        } else if (type === 'delete') {
          this.handleDelete();
        } else if (type === 'addPaymentDocument') {
          this.addPaymentDocument();
        } else if (type === 'submit') {
          this.beforeSubmit();
        } else if (type === 'payment') {
          this.payment();
        } else if (type === 'import') {
          this.handleImport();
        } else if (type == 'createPayBill') {
          // 生成应付票据
          this.createPayBill();
        } else if (type == 'copy') {
          // 复制
          this.handleCopy();
        }
      },
      //批量上传
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true, '05');
      },
      // 复制
      handleCopy() {
        if (this.multipleSelection.length !== 1) {
          this.$message({
            showClose: true,
            message: '请选择一条数据修改',
            type: 'error',
          });
        } else {
          const item = this.multipleSelection[0];
          let path = {
            path: '/payment/paymentApplyAdd',
            name: 'paymentApplyAdd',
            meta: {
              keepAlive: true,
              title: '付款申请单编辑',
            },
            query: { id: item.id, isEdit: 'Y', flag: 'copy' },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        }
      },
      // 比例提交前校验
      beforeSubmit() {
        if (this.multipleSelection.length == 0) {
          this.$message({
            showClose: true,
            message: '请选择数据再提交',
            type: 'error',
          });
          return;
        }
        let flag = true;
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (
            this.multipleSelection[i].requestStatus !== 'Saved' &&
            this.multipleSelection[i].requestStatus !== 'Withdraw' &&
            this.multipleSelection[i].requestStatus !== 'Rejected'
          ) {
            flag = false;
            break;
          }
        }
        if (!flag) {
          this.$message({
            showClose: true,
            message: '只能选择保存,已驳回，已撤回状态的记录！',
            type: 'error',
          });
          return;
        }
        loading.startLoading();
        this.$axios
          .post(API.BEFORE_BATCHSUBMIT, {
            idList: this.multipleSelection.map((it) => it.id),
            businessGroup: this.userInfo.businessGroup,
          })
          .then((res) => {
            loading.endLoading();
            if (res.data.code === 0) {
              this.submit();
            } else if (res.data.code === 9) {
              this.$confirmAction('提示', res.data.msg)
                .then(() => {
                  this.submit();
                })
                .catch(() => {
                  this.$message({
                    showClose: true,
                    type: 'info',
                    message: '取消提交',
                  });
                });
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          })
          .catch(() => loading.endLoading());
      },
      // 提交审批--批量
      submit(cancelValidate = false) {
        // 提交审批前校验
        this.$axios
          .post(API.BEFOR_CHECK_LISTAPRROVE + (cancelValidate ? '?cancelValidate=true' : ''), {
            idList: this.multipleSelection.map((it) => it.id),
            businessGroup: this.userInfo.businessGroup,
          })
          .then((res) => {
            console.log('res', res);
            if (res.data.data) {
              this.$confirmAction('确认', res.data.data + ',是否继续？')
                .then(() => {
                  console.log('继续');
                  this.submit1(cancelValidate);
                })
                .catch(() => {
                  // isSubmit = false;
                  return;
                });
            } else {
              this.submit1(cancelValidate);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      },
      // 批量提交审批
      submit1(cancelValidate = false) {
        loading.startLoading();
        this.$axios
          .post(API.SUBMIT + (cancelValidate ? '?cancelValidate=true' : ''), {
            idList: this.multipleSelection.map((it) => it.id),
            businessGroup: this.userInfo.businessGroup,
          })
          .then((res) => {
            loading.endLoading();
            if (0 == res.data.code) {
              this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              this.getNoCheckData();
            } else {
              this.$reportErrors({
                msg: res.data.msg,
                code: res.data.code,
                callback: () => {
                  //确认提交，cancelValidate传值true取消校验
                  this.submit(true);
                },
              });
            }
          })
          .catch(() => loading.endLoading());
      },
      // 提交付款--批量
      payment() {
        this.$axios
          .post(
            API.BATCH_PAYMENT,
            this.multipleSelection.map((it) => it.id)
          )
          .then((res) => {
            loading.endLoading();
            if (0 == res.data.code) {
              this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              this.getNoCheckData();
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
      },
      // 删除
      handleDelete() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected', 'error');
        }
        let canDelitems = [];
        for (let i = 0; i < this.multipleSelection.length; i++) {
          let temp = this.multipleSelection[i];
          if (
            temp.requestStatus != 'Saved' &&
            temp.requestStatus != 'Rejected' &&
            temp.requestStatus != 'Withdraw'
          ) {
            this.$message({
              showClose: true,
              message: '只能删除保存,已驳回和已撤回状态的单据！',
              type: 'error',
            });
            return false;
          } else {
            canDelitems.push(temp['id']);
          }
        }
        this.$confirmAction()
          .then(() => {
            this.del(canDelitems);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      resetBtnClickBtn() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        if (this.userInfo.companyCode != 'OAC19') {
          // this.query.requestCompanyCode = this.userInfo.companyCode;
          // this.query.requestDepartmentCode = this.userInfo.departmentCode;
          // this.getdepartmentList(this.query.requestCompanyCode);
        }

        this.getData();
      },
      // 删除/撤销
      del(ids) {
        this.$axios.post(API.PAYMENT_APPLY_DELETE, ids).then((res) => {
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClickBtn();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //新增
      add() {
        let path = {
          path: '/payment/paymentApplyAdd',
          name: 'paymentApplyAdd',
          meta: {
            keepAlive: true,
            title: '付款申请单创建',
          },
          query: { isEdit: 'Y' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },

      // 跳转详情页
      dblclickEvent(e) {
        let path = {
          path: '/payment/paymentApplyDetail',
          name: 'paymentApplyDetail',
          meta: {
            keepAlive: true,
            title: '付款申请单详情',
          },
          query: { id: e.row.id, isEdit: 'N' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          changeList.forEach((item) => {
            str += 'detailIds=' + item.detailId + '&';
          });
          window.location.href = `${this.baseUrl}${API.EXPORT_FUND_PAYMENT_APPLY}?${str}access_token=${this.userInfo.access_token}&businessGroup=${this.userInfo.businessGroup}`;
        } else {
          let params = this.setSearchParams();
          delete params.pageNum;
          delete params.pageSize;
          params = XEUtils.serialize(params);
          var reg = new RegExp('%5B%5D', 'g');
          params = params.replace(reg, '');
          window.location.href = `${this.baseUrl}${API.EXPORT_FUND_PAYMENT_APPLY}?${params}&access_token=${this.userInfo.access_token}&businessGroup=${this.userInfo.businessGroup}`;
        }
      },
      // 生成付款单
      addPaymentDocument() {
        if (this.multipleSelection.length <= 0) {
          this.$message({
            showClose: true,
            message: '请选择一条数据',
            type: 'error',
          });
        } else {
          let params = qs.stringify({ ids: this.multipleSelection.map((i) => i.id).join(',') });
          this.$axios.post(API.CHECK_FOR_CREATE_PAYMENT, params).then((res) => {
            if (0 == res.data.code) {
              let path = {
                path: '/payment/paymentAdd',
                name: 'paymentAdd',
                query: { ids: this.multipleSelection.map((i) => i.id).join(',') },
                meta: {
                  keepAlive: true,
                  title: '付款单创建',
                },
              };
              this.$store.dispatch('tagsView/addTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path);
                });
              });
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        }
      },
      // 生成应付票据
      createPayBill() {
        if (this.multipleSelection.length != 1) {
          return this.$message({ showClose: true, message: '请选择一条数据', type: 'error' });
        }
        if (
          this.multipleSelection[0].requestStatus != 'Approved' ||
          this.multipleSelection[0].paymentType == 'PT03' ||
          this.multipleSelection[0].paymentType == 'PT04'
        ) {
          return this.$message({
            showClose: true,
            message: '只能选择已通过的数据并且付款类别不能为客户退款-有合同和客户退款-无合同',
            type: 'error',
          });
        }
        let path = {
          path: '/capital/payBillAdd',
          name: 'payBillAdd',
          meta: {
            keepAlive: true,
          },
          query: { paymentApplyId: this.multipleSelection[0].id },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
